module.exports = __webpack_public_path__ + "static/media/Atmos_start.6fb07b93.mp4";